<template>
	<div class="login-view" id="loginView" v-if="isShowStatus==1">
		<h2>{{titleText}}</h2>
		<div class="login-register_view" v-if="loginType !== 3">
			<span>{{ titleTextHint }}</span>
			<span v-if="loginType == 2" class="set_color" @click="() => { loginType = 1 }">{{ $t('LoginTitle')}}</span>
			<span v-if="loginType == 1" class="set_color"
				@click="() => { loginType = 2 }">{{$t('dcolingo_register_title')}}</span>
		</div>
		<!-- 其他登录方式 -->
		<div class="other_login_way" v-if="loginType !== 3 && hasAuthProviders">
			<div class="other_login_way_google other_login_item" @click="onLoginGoogle" v-if="hasAuthProvider('google')">
				<img src="/assets/images/login/icon_Google.png" alt="">
				<span class="other_title">{{ $t('dcolingo_continue_goole')}}</span>
			</div>
			<div class="other_login_way_apple other_login_item" @click="onLinuxDo" v-if="hasAuthProvider('linuxdo')">
				<img src="/assets/images/login/linuxdo.png" alt="">
				<span class="other_title">{{ $t('dcolingo_continue_apple') }}</span>
			</div>
			<div class="other_login_way_Twitter_border other_login_item" @click="onLoginTwitter" v-if="hasAuthProvider('twitter')">
				<i class="iconfont icon-icon_twitter1"></i>
				<!-- <img src="/assets/images/linuxdo.png" alt=""> -->
				<span class="other_title other_login_way_Twitter">{{ $t('dcolingo_continue_twitter') }}</span>
			</div>
			<div class="other_login_way_Facebook_border other_login_item" @click="onLoginFacebook" v-if="hasAuthProvider('facebook')">
				<i class="iconfont icon-icon_facebook"></i>
				<!-- <img src="/assets/images/linuxdo.png" alt=""> -->
				<span class="other_title other_login_way_Facebook">{{ $t('dcolingo_continue_Facebook') }}</span>
			</div>
			<div class="other_login_way_qq_border other_login_item" @click="onLoginqq" v-if="hasAuthProvider('qq')">
				<i class="iconfont icon-icon_qq"></i>
				<!-- <img src="/assets/images/linuxdo.png" alt=""> -->
				<span class="other_title other_login_way_qq">{{ $t('dcolingo_continue_qq') }}</span>
			</div>
			<div class="other_login_way_wx_border other_login_item" @click="onLoginWx" v-if="hasAuthProvider('wechat')">
				<i class="iconfont icon-icon_wx"></i>
				<!-- <img src="/assets/images/linuxdo.png" alt=""> -->
				<span class="other_title other_login_way_wx">{{ $t('dcolingo_continue_wx') }}</span>
			</div>
		</div>
		<!-- 登录分割线 -->
		<div class="other_login_divider" v-if="loginType !== 3">
			<span class="login_divider"></span>
			<span class="login_divider_text">{{ $t('dcolingo_perhaps')}}</span>
			<span class="login_divider"></span>
		</div>
		<div class="login_from_view">
			<!-- 邮箱 -->
			<div class="loginItem" :class="{ 'setBorder': errorEmailTip }">
				<div class="loginItem_left">
					<i class="iconfont icon-icon_email1"></i>
				</div>
				<div class="loginItem_right">
					<div :class="[isEmailFocused || form.userEmail ? 'WJzhL' : 'egRvtE']">{{ $t('dcolingo_email') }}</div>
					<input ref="emailRef" type="email" autocomplete="email" @input="onCheck" class="enPiKg"
						@focus="onFocus('email')" @blur="onBlur('email')" v-model="form.userEmail" />
				</div>
			</div>
			<p class="errorTip" v-if="errorEmailTip">{{ $t('inputEmailTips1')}}</p>
			<!-- 验证码 -->
			<div class="loginItem" v-if="loginType !== 1">
				<div class="loginItem_left">
					<i class="iconfont icon-icon_lock"></i>
				</div>
				<div class="loginItem_right">
					<div :class="[isCheckCodeFocused || form.checkCode ? 'WJzhL' : 'egRvtE']">{{ $t('dcolingo_checkCode') }}</div>
					<input ref="codeRef" @input="onCodeInput" @paste="onCodePaste" class="enPiKg" inputmode="numeric"
						autocomplete="one-time-code" maxlength="6" @focus="onFocus('checkCode')" @blur="onBlur('checkCode')"
						v-model="form.checkCode" />
					<div class="codeIcon">
						<PDFButton :title="codeText === 'LoginGetCode' ? $t(`${codeText}`) : codeText" color="transparent"
							textColor="#2590E1" customFontSize="14px" paddingH="0" paddingTop="0 10px 0 0"
							@ButtonClick="onRegistCode" />
					</div>
				</div>
			</div>
			<!-- 密码 -->
			<div class="loginItem" :class="{ 'setBorder': errorPasswordTip }">
				<div class="loginItem_left">
					<i class="iconfont icon-icon_lock"></i>
				</div>
				<div class="loginItem_right">
					<div :class="[isPasswordFocused || form.password ? 'WJzhL' : 'egRvtE']">{{ passwordPlaceholderString }}</div>
					<input ref="passwordRef" type="password" @input="onCheck" class="enPiKg" @focus="onFocus('password')"
						@blur="onBlur('password')" v-model="form.password" />
				</div>
			</div>
			<p class="errorTip" v-if="errorPasswordTip">{{ $t('dcolingo_password_register_placeholder') }}</p>
			<!-- 邀请码，只有注册时显示 -->
			<div class="loginItem" :class="{ 'setBorder': errorPasswordTip }" v-if="loginType == 2">
				<div class="loginItem_left">
					<i class="iconfont icon-icon_membership_code"></i>
				</div>
				<div class="loginItem_right">
					<div :class="[isOwnLinkCodeFocused || form.ownLinkCode ? 'WJzhL' : 'egRvtE']">{{
						$t('business_dcolingo_invitation_code') }}
					</div>
					<input ref="ownLinkCodeRef" @input="onCheck" class="enPiKg" @focus="onFocus('ownLinkCode')"
						@blur="onBlur('ownLinkCode')" v-model="form.ownLinkCode" />
				</div>
			</div>
		</div>
		<div class="loginBtn" v-if="loginType === 1">
			<PDFStatsButton :title="$t(`LoginTitle`)" :isDisable="isBtnDisable" :color="isBtnDisable ? `#D3E9F9` : `#2590E1`"
				textColor="white" customFontSize="14px" paddingTop="0 0" paddingH="0 0" @ButtonClick="onLogin" />

		</div>
		<div class="loginBtn" v-if="loginType === 2">
			<PDFStatsButton :title="$t(`Register`)" :isDisable="isBtnDisable" :color="isBtnDisable ? `#D3E9F9` : `#2590E1`"
				textColor="white" customFontSize="14px" paddingTop="0 0" paddingH="0 0" @ButtonClick="onRequestRegister" />
		</div>
		<div class="loginBtn " v-if="loginType === 3">
			<PDFStatsButton :title="$t(`confirm`)" :isDisable="isBtnDisable" :color="isBtnDisable ? `#D3E9F9` : `#2590E1`"
				textColor="white" customFontSize="14px" paddingTop="0 0" paddingH="0 0" @ButtonClick="onForgetConfirm" />
		</div>
		<div class="loginForget" v-if="loginType === 1|| loginType === 3">
			<div class="tipsTitle1" @click="onForget" v-if="loginType === 1">{{ $t(`LoginForget`) }}</div>
			<div class="tipsTitle1" @click="() => { loginType = 1 }" v-if="loginType === 3">{{ $t(`LoginTitle`) }}</div>
		</div>
		<div class="loginTips k-shake" v-if="loginType == 2">
			<div class="tipsTitle">{{ $t(`dcolingo_not_account1`) }}</div>
			<div class="tipsTitle1" @click="(() => { onAgreement(1) })">{{ $t(`LoginAgreement`) }}</div>
			<div class="tipsTitle">{{ $t(`LoginAnd`) }}</div>
			<div class="tipsTitle1" @click="(() => { onAgreement(2) })">{{ $t(`LoginPrivacy`) }}</div>
		</div>
	</div>

	<!-- 这段代码暂时不需要， 暂时保留 -->
	<div class="wx_scan_view" v-if="isShowStatus == 2">
		<p>微信扫码登录</p>
		<div class="back" @click="onBack">
			<i class="iconfont icon-icon_return" />
			<p class="title">{{ $t("back") }}</p>
		</div>
		<canvas ref="wxCanvas"></canvas>
	</div>
</template>

<script setup lang='ts'>


 import {ref,reactive,watch} from "vue";
 import { useI18n } from "vue-i18n";
 const { t, locale } = useI18n();
//  import { isMobileOrTablet } from "@/utils"
 import Toast from '@/utils/toast'
 import eventBus from "vue3-eventbus";
 import useUserStore from "@/store/modules/user";
 import useProStore from "@/store/modules/pro";
 import useBaseStore from "@/store/modules/basic";
 import {storeToRefs} from "pinia";
 import PDFStatsButton from '@/components/Button/PDFStatsButton.vue'
 import PDFButton from '@/components/Button/PDFButton.vue'
 import UserServer from "~/services/UserServer";
 import { useCrossDomainCookie} from "@/composables/useCrossDomainCookie";
 import { useSiteConfig } from "@/config/useSiteConfig";
 import { sanitizeCode } from "@/utils/verifyCode";
//  import {
// 		getEmailAccountRegist,
// 		getEmailAccountLogin,
// 		getEmailAccountCode,
// 		getRequestAccountUserInfo,
// 		getRequestConfig,
// 		getRequestUserBankCardList,
// 		getPDFLanguageList,
// 		getEmailAccountForget,
// 		getWxauthUrl,
// 		getTwitterOauthUrl,
// 		getFacebookOauthlogin,
// 	} from "@/net/upload";
//  import { registEmailStatistics, loginEmailStatistics } from "@/config/googleStatistics";
 const router = useRouter();
 const route = useRoute();
 const userStore = useUserStore();
 const userProStore = useProStore();
 const baseStore = useBaseStore();
 const { userInfo, token }  = storeToRefs(userStore);
 const { proConfig }  = storeToRefs(userProStore);
 const { languages }  = storeToRefs(baseStore);

const { facebookLogin } = useFacebookLogin('1091357012928662');
const { createCrossDomainCookie, getCrossDomainCookie} = useCrossDomainCookie();
const siteConfig = useSiteConfig();

const wxCanvas = ref()


interface Props {
	isDrawer: any;  //使用场景 "center", header 目前两个场景，
}
const props = defineProps<Props>()


const { $loginCom } = useNuxtApp();
const showLogin = () => {
	$loginCom.open();
};
const closeLogin = () => {
	$loginCom.close();
};

const isShowStatus = ref(1);
 const loginType = ref(1);   // 1 登录 2 注册 3 忘记密码

 const titleText = computed(()=>{
  if (loginType.value == 1) {
    return t('dcolingo_login_title')
	} else if (loginType.value == 2){
		return t('dcolingo_register_title_hint')
	} else if (loginType.value == 3){
		return t("LoginForget").replace(/\?/g, '') 
	}
	 
 })
 const titleTextHint = computed(()=>{
  if (loginType.value == 1) {
		return t('dcolingo_not_account')
  } else {
		return t('dcolingo_have_account')
  }
	 
 })

let isBtnDisable = ref(true)
let emailRef = ref()
let codeRef = ref()
let passwordRef = ref()
const codeText = ref("LoginGetCode");
const timeId = ref(null);

const form = reactive({
	userEmail: '',
	checkCode: '',
  password: '',
	ownLinkCode: ''
})

const unwrapConfigValue = (value: any) => {
	return value && typeof value === 'object' && 'value' in value ? value.value : value
}
const authProviders = computed(() => {
	const providers = unwrapConfigValue(siteConfig.authProviders)
	return Array.isArray(providers) ? providers : []
})
const hasAuthProviders = computed(() => authProviders.value.length > 0)
const hasAuthProvider = (provider: string) => authProviders.value.includes(provider)


const isEmailFocused = ref(false);
const isPasswordFocused = ref(false);
const isOwnLinkCodeFocused = ref(false);
const isCheckCodeFocused = ref(false);
let focusMap = {
	email: isEmailFocused,
	checkCode: isCheckCodeFocused,
	password: isPasswordFocused,
	ownLinkCode: isOwnLinkCodeFocused
};
const onFocus = (str: string) => {
	if (focusMap[str]) {
		focusMap[str].value = true;
	}
}
const onBlur = (str: string) =>{
	if (focusMap[str]) {
		focusMap[str].value = false;
	}
}


const codeTime = () => {
	let time = 119;
	if (!(codeText.value === "LoginGetCode")) return;
	codeText.value = time + 'S'
	// @ts-ignore
	timeId.value = setInterval(() => {
		if (time <= 0) {
			// @ts-ignore
			clearInterval(timeId.value);
			timeId.value = null
			codeText.value = "LoginGetCode"
		} else {
			time--;
			codeText.value = time + 'S'
		}
	}, 1000)
}


function onRegistCode() {
	if (codeText.value !== 'LoginGetCode'){
		return;
	}
	codeTime()
	// 先归一化再校验：否则 " a@b.com " 会被下面的锚定正则判为格式错误，
	// 用户看到一个明明合法的邮箱被拒，而提交处的 trim 永远执行不到。
	form.userEmail = form.userEmail.trim()
	if (form.userEmail && form.userEmail.length > 0) {
		// 做正则校验邮箱是否合格
		if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(form.userEmail)) {
			Toast(t("inputEmailTips1"))
			return;
		}
		let num = {
			2: 1,
			3: 2
		}[loginType.value] || 1;

		let req = { sendType: num, userEmail: form.userEmail.trim() }
		UserServer.getAccountEmailCode(req).then((data) => {
			Toast(data.message)
		})
	} else {
		Toast(t("inputEmailTips"))
	}
}

const passwordPlaceholderString = computed(() => {
	return loginType.value == 3 ? t("newPassword") : t("dcolingo_password")
})



watch(() => loginType.value, () => {
	onClearInput()
	errorEmailTip.value = false;
	errorPasswordTip.value = false;
	emailFoucs()
})
function onClearInput() {
	form.userEmail = "";
	form.checkCode = "";
	form.password = "";
}

// 验证码输入：先清洗再走原来的按钮可用性判断
function onCodeInput() {
	form.checkCode = sanitizeCode(form.checkCode)
	onCheck()
}

// 同 PDFInput：必须 preventDefault 后先洗再截断，否则 maxlength 会先吃掉一位
function onCodePaste(e) {
	e.preventDefault()
	const clip = (e.clipboardData || (window as any).clipboardData)
	const text = clip ? clip.getData('text') : ''
	form.checkCode = sanitizeCode(text).slice(0, 6)
	onCheck()
}

// 使用策略模式，来监听绑定输入框的值是否有输入，全部输入后，可进行下一步操作
function onCheck() {
	if (loginType.value === 1) {
		isBtnDisable.value = !validateFields(form.userEmail, form.password);
	} else if (loginType.value === 2) {
		isBtnDisable.value = !validateFields(form.userEmail, form.password, form.checkCode);
	} else if (loginType.value === 3) {
		isBtnDisable.value = !validateFields(form.userEmail, form.password, form.checkCode);
	}
}
// 由于传人的ref，都是输入框绑定的， 所以都带有inputValue， 所以可以使用扩展运算符+结构来传参数，
function validateFields(...fields): boolean {
	return fields.every(field => field && field.length > 0);
}

const errorEmailTip = ref(false);
const errorPasswordTip = ref(false);

//校验邮箱规则
const checkEmail = async() => {
	// 同 onRegistCode：校验前先归一化，让输入框里显示的和最终提交的一致
	form.userEmail = form.userEmail.trim()
	const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	return new Promise<void>((resolve, reject) => {
		if (!regex.test(form.userEmail)) {
			errorEmailTip.value = true;
			reject()
		} else {
			errorEmailTip.value = false;
			resolve()
		}
	})
}
const checkPassword = async(forSetting = true) => {
	// forSetting=true：设置新密码（注册/重置），必须对齐后端 checkPasswordSet 的 8-64。
	// forSetting=false：输入已有密码（登录），只能校验非空。
	//   后端登录只比对哈希、不走 checkPasswordSet，而历史下限是 6，
	//   存量用户里有 6-7 位密码，登录处按 8 位拦截会把他们直接锁在门外。
	const regex = forSetting ? /^(?!.*\s).{8,64}$/ : /^.{1,64}$/;
	return new Promise<void>((resolve, reject) => {
		if (!regex.test(form.password)) {
			errorPasswordTip.value = true;
			reject()
		} else {
			errorPasswordTip.value = false;
			resolve()
		}
	})
}




// 登录事件
const onLogin = async () => {
	console.log('是否触发会车键')
	try {
		await checkEmail()
		await checkPassword(false)
		let req = { password: form.password, userEmail: form.userEmail.trim() }
		let dialog = document.getElementById("loginView")
		let loading;
		if (dialog) {
			loading = ElLoading.service({
				lock: true,
				target: dialog
			})
		}
		userStore.login(req, ()=>{
			// getUserByToken()
			getConfig()
			Toast(t("Login_success"));
			// loginEmailStatistics()
			closeLogin()
			loading.close()
		}, (message)=>{
			loading.close()
			if (message){
				Toast(message)
			}
		})
	} catch (error) {
		console.log('登录事件错误', error)
	}
	
}

// 注册事件
const onRequestRegister = async() =>{
	try { 
		await checkEmail()
		await checkPassword()
		let req = { checkCode: sanitizeCode(form.checkCode), password: form.password, userEmail: form.userEmail.trim() }
		let dialog = document.getElementById("loginView")
		let loading;
		if (dialog) {
			loading = ElLoading.service({
				lock: true,
				target: dialog
			})
		}
		if (form.ownLinkCode){
			req['ownLinkCode'] = form.ownLinkCode
		}
		userStore.getAccountRegist(req, ()=>{
			// getUserByToken()
			Toast(t("LoginRegister_success"));
			closeLogin()
			loading.close()
			// registEmailStatistics()
		}, (message)=>{
			loading.close()
			if (message){
				Toast(message)
			}
		})
	} catch (error) {
		console.log('创建账户事件', error)
	}
	
}


// 忘记密码的确认事件
const onForgetConfirm = async() => {
	try  { 
		await checkEmail()
		await checkPassword()
		let req = { emailCheckCode: sanitizeCode(form.checkCode), newPassword: form.password, userEmail: form.userEmail.trim() }
		let dialog = document.getElementById("loginView")
		let loading;
		if (dialog) {
			loading = ElLoading.service({
				lock: true,
				target: dialog
			})
		}
		UserServer.getAccountForget(req).then((data) => {
			if (data.code == '1') {
				token.value = data.data
				getUserByToken('ForgetConfirm')
				Toast(t('accountEditSuccess'));
				loginType.value = 1
				onClearInput()
			}else{
			}
			loading.close();
		}).catch((error) => {
			loading.close();
			Toast(error.message);
		})
	} catch (error) {
		console.log('忘记密码',error)
	}
	
}

function getConfig() {
	baseStore.getHomePageConfig()
}

function getUserByToken(typeStr?: any) {
	UserServer.getUserInfo().then((data) => {
		if (data.code == "1") {
			if (typeStr === "ForgetConfirm") {
				onClearInput()
				onCheck()
				loginType.value = 1
			} else {
				// 正常的登录，以及注册的逻辑
				let deviceId = getCrossDomainCookie('deviceId').value || localStorage.getItem("deviceId") || ''
				
				closeLogin()
				eventBus.emit('loginSuccess', 1);
				onClearInput()
				setClarity(deviceId)
				getRequestPDFLanguageList()
				// onRequestBankCardList()
			}

		}
	}).catch((error) => {
		// Toast(error.message);
	})
}
function getRequestPDFLanguageList() {
	baseStore.getLanguages()
}

function setClarity(deviceId) {
	let userIdentify = deviceId
	let identity = ""
	if (token.value && userInfo.value.id) {
		userIdentify = userInfo.value.id
		if (userInfo.value.vipLevel == 1) {
			identity = "-vip"
		} else if (userInfo.value.vipLevel == 2) {
			identity = "-svip"
		}
	}
	if (window.clarity) {
		window.clarity("identify", `${userIdentify}`)
	}
	if (window.$crisp) {
		if (userInfo.value.email) {
			window.$crisp.push(["set", "user:email", [userInfo.value.email]]);
		}
		window.$crisp.push(["set", "user:nickname", [`web${identity}-${userIdentify}`]]);
	}
}

// 协议，服务条款
const onAgreement = (type) => {
	const { href } = router.resolve({
		path: '/account/privacyAgreement',
		query: { type: type },
	});
	window.open(href, '_blank');
}
// 忘记密码
const onForget = () => {
	// 响应式H5页面s
	// if (isMobileOrTablet()) {
	// 	loginType.value = 3
	// 	onClearInput()
	// } else {
	// 	const { href } = router.resolve({
	// 		path: '/login/forget'
	// 	});
	// 	window.open(href, '_blank');
	// }
	const { href } = router.resolve({
		path: '/login/forget'
	});
	window.open(href, '_blank');
}

const saveRouter = () => {
	localStorage.removeItem("loginRouter")
	localStorage.setItem("loginRouter", JSON.stringify({ url: useRoute().path, query: useRoute().query }))
}
const onLoginApple = () => {
	const params = new URLSearchParams({
		response_type: 'code',
		client_id: 'YOUR_CLIENT_ID', // 您的 App ID
		redirect_uri: `${useRuntimeConfig().public.VITE_GOOGLE_URL}login/loginResult`, // 回调地址
		scope: 'email name',
		state: `${new Date().getTime()}` // 用于防止 CSRF 攻击的随机字符串
	}).toString();
	const appleAuthUrl = `https://appleid.apple.com/auth/authorize?${params}`;
	window.location.href = appleAuthUrl;
}
async function onLinuxDo() {
	await createCrossDomainCookie('lang', locale.value)
	const appleAuthUrl = `${useRuntimeConfig().public.doclingoUrl}${locale.value}/login/enterprise?linuxdo=1`;
	window.location.href = appleAuthUrl;
	// saveRouter()
	// const authUrl = `https://connect.linux.do/oauth2/authorize?response_type=code&client_id=${useRuntimeConfig().public.linxdoClientId}&state=linuxdo`;
	// window.open(authUrl, '_blank');
}
const onLoginGoogle = async () => {
	await createCrossDomainCookie('lang', locale.value)
	const appleAuthUrl = `${useRuntimeConfig().public.doclingoUrl}${locale.value}/login/enterprise?google=1`;
	window.location.href = appleAuthUrl;
	// saveRouter()
	// const authParams = new URLSearchParams({
	// 	response_type: 'code', //固定
	// 	client_id: `${useRuntimeConfig().public.googleId}`, // 请将 YOUR_CLIENT_ID 替换为实际的客户端 ID
	// 	scope: 'openid email profile',  //固定
	// 	redirect_uri: `${useRuntimeConfig().public.linkUrl}login/loginResult`, // 在Google配置的回调url
	// });
	// const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?${authParams}`;

	// window.location.href = authUrl
}

// 第三方qq登录
const onLoginqq = async () => { 
	await createCrossDomainCookie('lang', locale.value)
	const appleAuthUrl = `${useRuntimeConfig().public.doclingoUrl}${locale.value}/login/enterprise?qq=1`;
	window.location.href = appleAuthUrl;
	// let params = {
	// 	redirectUrl: `${useRuntimeConfig().public.linkUrl}login/qq/loginResult`,
	// 	state: new Date().getTime(),
	// 	appid: useRuntimeConfig().public.qqKey,
	// 	display: 'pc' // display=mobile display=pc  对应移动端和PC端登录界面样式
	// }
	// // if (isMobileOrTablet()){
	// // 	params.appid = useRuntimeConfig().public.config.VITE_QQ_APPID_H5
	// // 	params.display = 'mobile'
	// // }
	// const encoded_uri = encodeURIComponent(params.redirectUrl);
	
	// let qqAuthUrl = `https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=${params.appid}&redirect_uri=${encoded_uri}&scope=get_user_info&state=${params.state}&display=pc`

	// console.log('qqUrl', encoded_uri)

	// window.location.href = qqAuthUrl;
}
function isWeChatInBrowser() {
	const ua = navigator.userAgent.toLowerCase()
	// return /micromessenger/.test(ua) 
	return /micromessenger/.test(ua) || /WindowsWechat/i.test(ua)
}
function isMobile() {
	return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
}
const wxUrl = ref("");
// 第三方微信登录
const onLoginWx = async () => { 
	await createCrossDomainCookie('lang', locale.value)
	const appleAuthUrl = `${useRuntimeConfig().public.doclingoUrl}${locale.value}/login/enterprise?wechat=1`;
	window.location.href = appleAuthUrl;
  // isShowStatus.value = 2;
	// let params = {
	// 	redirectUrl: `${useRuntimeConfig().public.linkUrl}login/wx/loginResult`,
	// 	state: new Date().getTime(),
	// 	appid: useRuntimeConfig().public.weixinKey,
	// 	scope: 'snsapi_login',
	// 	oauthUrl: 'https://open.weixin.qq.com/connect/qrconnect'
	// }
	// //  这里后面用来处理， 在微信环境下使用我们的应用时，处理的授权地址
	// // if (isWeChatInBrowser()) {
	// // 	params.appid = useRuntimeConfig().public.config.VITE_WX_APPID_H5
	// // 	params.scope = 'snsapi_userinfo'
	// // 	params.oauthUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize'
	// // }
	// const encoded_uri = encodeURIComponent(params.redirectUrl);
	// let WeChatUrl = `${params.oauthUrl}?appid=${params.appid}&response_type=code&scope=${params.scope}&redirect_uri=${encoded_uri}&state=${params.state}#wechat_redirect`
	
	// window.location.href = WeChatUrl;
}
// 第三方Twitter 授权登录
const onLoginTwitter = async () => { 
	await createCrossDomainCookie('lang', locale.value)
	const appleAuthUrl = `${useRuntimeConfig().public.doclingoUrl}${locale.value}/login/enterprise?twitter=1`;
	window.location.href = appleAuthUrl;
	// UserServer.getTwitterOauthUrlApi().then((data) => {
	// 	if (data.code == "1") {
	// 		window.location.href = `${data.data}`;
	// 	}
	// }).catch((error) => {
	// 	Toast(error.message);
	// })
}
interface FacebookLoginResponse {
	accessToken: string;
	userID: string;
}

// 第三方facebook 授权登录
const onLoginFacebook = async  () => { 
	await createCrossDomainCookie('lang', locale.value)
	const appleAuthUrl = `${useRuntimeConfig().public.doclingoUrl}${locale.value}/login/enterprise?facebook=1`;
	window.location.href = appleAuthUrl;
	// try {
	// 	let { accessToken } = await facebookLogin() as FacebookLoginResponse;
	// 	let params = { inputToken: accessToken }
	// 	UserServer.getFacebookOauthlogin(params).then((data) => {
	// 		if (data.code == "1") {
	// 			if (token.value != data.data) {
	// 				token.value = data.data
	// 			}
	// 			getUserByToken()
	// 			Toast(t("Login_success"));
	// 		}
	// 	}).catch((error) => {
	// 		Toast(error.message);
	// 	})
		
	// 	// 发送到后端
	// } catch (e) {
	// 	console.error(e);
	// }
	
}

const onBack = () => {
	isShowStatus.value = 1;
}





// 存储 setTimeout 的 ID，便于后续清除
const emailFocusTimeout = ref<any>(null)
const emailFoucs = () => {
	// nextTick(() => {
	// 	if(!isMobileOrTablet()){
	// 		emailRef.value?.focus()
	// 	}
	// })
}

watch(() => props.isDrawer, (newVal) => {
	console.log('newVal=',newVal)	
	if(newVal){
		emailFocusTimeout.value = setTimeout(() => {
			emailFoucs()
		}, 1000)
	}else{
		if (emailFocusTimeout.value) {
			clearTimeout(emailFocusTimeout.value)
			emailFocusTimeout.value = null
		}
	}
},{
	immediate: true
})

// 按当前步骤分派：此前无条件调 onLogin()，在注册/忘记密码步骤按 Enter
// 会对尚不存在或密码不匹配的账号发出真实登录请求，可能计入后端风控计数。
const handleEnterKey = (event) => {
	if (event.key !== 'Enter' || !props.isDrawer) {
		return
	}
	// Enter 走 window 的 keyup，不经过按钮组件，拿不到 PDFStatsButton 里
	// `if (props.isDisable) return` 那道门禁。这里必须自己补上，否则字段没填全
	// （典型是验证码留空）时按 Enter 仍会发出带残缺参数的真实请求。
	if (isBtnDisable.value) {
		return
	}
	if (loginType.value === 2) {
		onRequestRegister()
	} else if (loginType.value === 3) {
		onForgetConfirm()
	} else {
		onLogin()
	}
}

onMounted(() => {
	emailFoucs()
	window.addEventListener('keyup', handleEnterKey)
	console.log('onMounted', useRuntimeConfig())
})
// 组件卸载前清除定时器
onBeforeUnmount(() => {
  if (emailFocusTimeout.value) {
    clearTimeout(emailFocusTimeout.value)
    emailFocusTimeout.value = null
  }
	window.removeEventListener('keyup', handleEnterKey)
})

</script>

<style scoped lang='scss'>
.login-view{
	text-align: center;
	width: 340px;
	margin: 0 auto;
	.login-register_view{
		margin:20px 0;
		span{
			font-size: 16px;
			color:#595959;
		}
		.set_color {
			color: #2590E1;
			cursor: pointer;
		}
	}
	.other_login_way{

	}
	.other_login_item{
		border:1px solid #595959;
		border-radius: 4px;
		display: flex;
		align-items: center;
		cursor: pointer;
		margin-bottom: 10px;
		img{
			width:24px;
			height:24px;
			margin:0 6px;
		}
		i{
			font-size: 24px;
			margin: 0 6px;
		}
		.icon-icon_qq{
			color: #4CAFE9;
		}
		.icon-icon_wx{
			color: #28C445;
		}
		.icon-icon_facebook{
			color: #235B9E;
		}
		.other_title{
			padding-left: 20px;
			display: inline-block;
			flex: 1;
			background-color: #595959;
			text-align: left;
			height:36px;
			line-height: 36px;
			color:#fff;
			font-size: 16px;
		}
	}
	.other_login_way_google{
		border: 1px solid #2590E1;
		.other_title {
			background-color: #2590E1;
		}
	}
	.other_login_way_qq_border{
		border:1px solid #4CAFE9 !important;
	}
	.other_login_way_qq{
		background-color: #4CAFE9 !important;
	}
	.other_login_way_Twitter_border {
		border: 1px solid #262626 !important;
	}
	.other_login_way_Facebook_border {
		border: 1px solid #235B9E !important;
	}
	.other_login_way_Twitter{
		background-color: #262626 !important;
	}
	.other_login_way_Facebook{
		background-color: #235B9E !important;
	}
	.other_login_way_wx_border{
		border: 1px solid #28C445 !important;
	}
	.other_login_way_wx{
		background-color: #28C445 !important;
	}

	.other_login_divider{
		margin-top: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		.login_divider{ 
			width: 35%;
			height:1px;
			background-color: #8C8C8C;
		}
		.login_divider_text{
			flex: 1;
			text-align: center;
			color: #8C8C8C;
		}
	}


	.loginBtn {
		display: flex;
		flex-direction: row-reverse;
		align-items: center;
		margin: 30px 0px 0 0px;
		width: 100%;
		height: 40px;
		justify-content: center;
	}
	.loginForget {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 15px 0 0 0;
		height: 20px;

		.tipsTitle1 {
			font-size: 14px;
			color: #2590E1;
			line-height: 12px;

			&:hover {
				border-bottom: 0.5px solid #2590E1;
				cursor: pointer;
			}
		}
	}
	
	.loginTips {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		margin: 10px 0 0 0;
		align-items: center;
		justify-content: center;
		.tipsTitle {
			font-size: 12px;
			color: #8C8C8C;
			line-height: 12px;
		}
		.tipsTitle1 {
			font-size: 11px;
			// color: #2590E1;
			color: #8C8C8C;
			line-height: 12px;
			border-bottom: 0.5px solid #8C8C8C;
			&:hover {
				
				// border-bottom: 0.5px solid #2590E1;
				cursor: pointer;
			}
		}
	}
	.loginItem{
		margin-top:15px;
		width: 100%;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		padding: 0px 8px;
		border-radius: 4px;
		background: rgb(255, 255, 255);
		border: 1px solid rgb(209, 209, 209);
		color: rgb(26, 26, 26);
		transition: border 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955);
	}
	.loginItem_right{
		display: flex;
		position: relative;
		flex: 1 1 0%;
	}
	.errorTip {
		color: #E14C25;
		font-size: 12px;
		text-align: left;
	}
	.setBorder{
		border: 1px solid #E14C25;
	}
	.enPiKg{
		line-height: 18px;
		font-size: 14px;
		font-family: "Source Sans 3", "Adjusted Arial Fallback", sans-serif;
		-webkit-font-smoothing: antialiased;
		font-weight: 400;
		color: rgb(33, 33, 33);
		display: block;
		width: 100%;
		height: 40px;
		box-sizing: border-box;
		padding: 18px 6px 6px;
		border: 0px;
		border-radius: 0px;
		outline: none;
		background: transparent;
		box-shadow: none;
	}
	.egRvtE{
		line-height: 18px;
		font-size: 14px;
		font-family: "Source Sans 3", "Adjusted Arial Fallback", sans-serif;
		-webkit-font-smoothing: antialiased;
		font-weight: 400;
		color: rgb(117, 117, 117);
		display: flex;
		position: absolute;
		-webkit-box-align: center;
		align-items: center;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding: 0px 8px;
		left: 0px;
		top: 0px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		transition: transform 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955), color 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955);
		transform-origin: left top;
		pointer-events: none;
	}
	.WJzhL {
		line-height: 18px;
		font-size: 14px;
		font-family: "Source Sans 3", "Adjusted Arial Fallback", sans-serif;
		-webkit-font-smoothing: antialiased;
		font-weight: 400;
		color: rgb(117, 117, 117);
		display: flex;
		position: absolute;
		-webkit-box-align: center;
		align-items: center;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding: 0px 8px;
		left: 0px;
		top: 0px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		transition: transform 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955), color 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955);
		transform-origin: left top;
		pointer-events: none;
		transform: scale(0.85) translateY(-7px);
	}
	.codeIcon{
		display: flex;
		align-items: center;
		font-size: 14px ;
	}
	
}

.wx_scan_view{
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	width: 340px;
	margin: 0 auto;
	.back {
		display: flex;
		flex-direction: row;
		align-items: center;
		cursor: pointer;
		margin:15px 0 10px 0;
		&:hover {
			opacity: 0.6;
		}
		.icon-icon_return {
			font-size: 20px;
			color: #2590E1;
			margin-right: 5px;
		}
		.title {
			font-size: 14px;
			color: #2590E1;
		}
	}
}
</style>
<style>
.login-view input {
    font-size: 16px !important; /* 设置字体大小 */
}

</style>
